import React, { useState } from "react";
import { ChevronDown, ChevronUp } from "lucide-react";
import { useLanguage } from "../../context/LanguageContext";

const ArbitratorCard = ({ arbitrator, lang }) => {
  const { t } = useLanguage();
  const [isOpen, setIsOpen] = useState(false);
  const name = arbitrator.name[lang] || arbitrator.name.ru;
  const experience = arbitrator.experience[lang] || arbitrator.experience.ru;

  const toggleOpen = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className="border border-gray-200 rounded-lg shadow-sm mb-4">
      <button
        onClick={toggleOpen}
        className="w-full flex justify-between items-center p-5 text-left bg-gray-50 hover:bg-gray-100 focus:outline-none"
      >
        <h3 className="text-xl font-semibold text-gray-800">
          {name}
        </h3>
        {isOpen ? (
          <ChevronUp className="w-6 h-6 text-blue-600" />
        ) : (
          <ChevronDown className="w-6 h-6 text-gray-500" />
        )}
      </button>
      {isOpen && (
        <div className="p-5 border-t border-gray-200 bg-white">
          <h4 className="font-bold text-gray-700 mb-2">
            {t("arbitrator_card_title")}
          </h4>
          <p className="whitespace-pre-line text-gray-600">
            {experience}
          </p>
        </div>
      )}
    </div>
  );
};

export default ArbitratorCard;
